import { BannerTertiary } from '@sbercloud/uikit-product-site-banner';
import { useRouter } from 'next/navigation';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';

export function ArticleBanner() {
  const layoutType = useLayoutType();
  const router = useRouter();
  const { clickAnalytics } = useAnalytics();

  const handleButtonClick = () => {
    const bannerLink = '/offers/free-test';

    clickAnalytics({
      action: bannerLink,
      clickContent: 'Получить',
      clickElement: 'button',
      clickZone: 'body',
      clickZoneCategory: 'site-body',
      transitionType: 'inside-link',
      uniqueId: 'article-banner',
      transitionTypeMetrics: 'internal',
      transitionUrl: bannerLink,
    });

    router.push('/offers/free-test');
  };

  return (
    <BannerTertiary
      layoutType={layoutType}
      appearance="decor"
      color="blue"
      title="Дарим до 20 000 бонусов"
      description="4 000 бонусов — физическим лицам, 20 000 бонусов — юридическим"
      img="https://cdn.cloud.ru/backend/carousel/main-carousel/20_bonus2502.png"
      button={{ label: 'Получить', onClick: handleButtonClick }}
      data-test-id="article-banner"
    />
  );
}
